import Axios from "axios";
import { ServiceUrl } from "../utils/serviceUrl";
import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";

export const listAcademicYears = async (status = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.ADMIN.LIST_ACADEMIC_YEARS}`;
    if (status) url = `${url}?status=${status}`;

    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          //toast.error(data.message || "Error");
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listBatches = async (status = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.ADMIN.LIST_BATCH}`;
    if (status) url = `${url}?status=${status}`;

    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          //toast.error(data.message || 'Error');
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listCollegeYears = async (status = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.ADMIN.COLLEGE_YEARS}`;
    if (status) url = `${url}?status=${status}`;

    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          //toast.error(data.message || 'Error');
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const currentSemesterStartAndEndDate = async (d = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.MOB.CURRENT_SEM_DATE}`;
    if (d) url += "?" + d;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          //toast.error(data.message || 'Error');
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const _CurrentSemesterStartAndEndDate = async (serachData = false) => {
  let url = ServiceUrl.MOB.CURRENT_SEM_DATE;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};

export const listCurrentBatches = async (condition = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.MOB.CURRENT_BATCHES}`;
    if (condition) url += "?" + condition;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status == "1") {
          //toast.error(data.message || 'Error');
          resolve(data);
        }
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const _listCurrentBatches = async (serachData = false) => {
  let url = ServiceUrl.MOB.CURRENT_BATCHES;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};

export const getDayValueByDate = async (d) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.MOB.DAY_VALUE_BY_DATE_STU}?${d}`;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          //toast.error(data.message || 'Error');
        }
        resolve(data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const _GetDayValueByDate = async (serachData = false) => {
  let url = ServiceUrl.MOB.DAY_VALUE_BY_DATE;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};
